export const SYNC_STATUS = {
  YOUR_SYNC_IS_ALREADY_IN_PROGRESS: "Your sync is already in progress",
  YOUR_SYNC_HAS_BEEN_STARTED: "Your Sync has been started",
  YOUR_MIGRATION_IS_ALREADY_IN_PROGRESS:
    "Your migration is already in progress",
  MIGRATION_COMPLETED_YOU_CAN_NOW_SYNC_YOUR_DATA:
    "Your migration has been completed, you can sync your data now",
  SYNC_HAS_BEEN_COMPLETED: "Sync has been completed",
};
